import React, { Fragment, useEffect, useRef, useState } from 'react';
import { withStyles } from '@material-ui/core';
import Calendar from 'react-calendar';
import moment from 'moment';
import ArrowRight from '../../asset/img/icon_calendar_nav_right.svg';
import ArrowLeft from '../../asset/img/icon_calendar_nav_left.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  calendar: {
    border: 'none',
    width: '100%',
    '-moz-box-sizing': 'border-box',
    '-webkit-box-sizing': 'border-box',
    'box-sizing': 'border-box',
    '& .react-calendar': {
      maxWidth: '100%',
      background: 'white',
      font: 'inherit',
      lineHeight: '1.125rem',
    },
    '& .react-calendar__viewContainer': {
      display: 'flex',
      width: '100%',
    },
    '& .react-calendar__month-view': {
      width: '100%',
    },
    '& .react-calendar button': {
      border: '0',
      // outline: 'none',
      margin: '0',
    },
    '& .react-calendar__navigation button': {
      minWidth: '2.75rem',
      background: 'none',
      padding: '0',
    },
    '& .react-calendar__month-view__weekdays': {
      textAlign: 'center',
      fontSize: '0.875rem',
      textTransform: 'uppercase',
      fontWeight: 'bold',
    },
    '& .react-calendar__month-view__weekNumbers': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      fontWeight: 'bold',
    },
    '& .react-calendar__navigation': {
      display: 'flex',
      font: 'inherit',
      // margin: "0rem 3.875rem",
      height: '2.75rem',
      marginBottom: '1em',
      alignItems: 'flex-start',
      '& button.react-calendar__navigation__label': {
        fontSize: '1.25rem',
        fontWeight: 'bold',
        color: '#000',
      },
      '& button:disabled': {
        backgroundColor: '#fff',
      },
      '& button:hover': {
        backgroundColor: '#fff',
      },
    },
    '& .react-calendar__month-view__weekdays abbr': {
      textDecoration: 'none',
    },
    '& .react-calendar__month-view__weekdays__weekday': {
      color: '#666',
      padding: '0.5rem 0rem',
    },
    '& .react-calendar__month-view__weekdays__weekday:first-child': {
      color: '#ff3723',
    },
    '& .react-calendar__month-view__weekdays__weekday--weekend': {
      color: '#327af4',
    },
    '& .react-calendar__month-view__days': {
      '& abbr': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    '& .react-calendar__tile': {
      background: '#fff',
    },
  },
  label2: {
    fontSize: theme.font.size12,
    color: '#666666',
    fontWeight: 400,
    lineHeight: 2,
  },
  calendarTileBtn: {
    width: '2rem',
    height: '2rem',
    borderRadius: '2rem',
    background: '#fff',
    textDecoration: 'none',
    fontSize: '0.875rem',
  },
  calendarTileBtnSat: {
    color: '#327af4 !important',
  },
  calendarTileBtnSun: {
    color: '#ff3723 !important',
  },
  tilesAvailable: {
    color: '#000',
    '& span': {
      color: '#000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
  },
  tilesAvailableSelected: {
    color: '#000',
    '& span': {
      color: '#fff !important',
      background: '#ea1917', //"#da0f47",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  tilesDisabled: {
    color: '#000',
    '& span': {
      opacity: '0.3',
      textDecoration: 'line-through',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
  },
  tilesHidden: {
    display: 'none',
  },
  navIcon: {
    width: '1rem',
    height: '1rem',
  },
  navIconDisable: {
    width: '0rem',
    height: '0rem',
    background: '#d4d4d4',
    borderRadius: '1rem',
    display: 'none',
  },
  legend: {
    paddingTop: '1.25rem',
    fontSize: theme.font.size12,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: '0.75rem',
      color: '#666666',
      // "&::before":{
      //     display: "flex",
      //     justifyContent: "center",
      //     alignItems: "center",
      //     width: "0.375rem",
      //     height: "0.375rem",
      //     marginRight: "0.25rem",
      //     backgroundColor: "#000",
      //     content: '""',
      //     borderRadius: "50%",
      // }
    },
  },
  legendAvailble: {
    '&::before': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '0.375rem',
      height: '0.375rem',
      marginRight: '0.25rem',
      backgroundColor: '#000',
      content: '""',
      borderRadius: '50%',
    },
  },
  legendSelected: {
    '&::before': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '0.375rem',
      height: '0.375rem',
      marginRight: '0.25rem',
      backgroundColor: '#ea1917', //"#da0f47",
      content: '""',
      borderRadius: '50%',
    },
  },
  legendDisable: {
    '&::before': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '0.375rem',
      height: '0.375rem',
      marginRight: '0.25rem',
      backgroundColor: '#ddd',
      content: '""',
      borderRadius: '50%',
    },
  },
});
function WeekView(props) {
  const { classes, possibleDate, getPossibleTime, scheduleUnlock, autoSelect } = props;
  const data = possibleDate;
  const startIndex = 0;
  const endIndex = data.length - 1;
  const startDateArr = data[startIndex].holiDt2.split('.');
  const endDateArr = data[endIndex].holiDt2.split('.');
  const startDate = new Date(
    startDateArr[0],
    parseInt(startDateArr[1]) - 1,
    startDateArr[2]
  );
  const endDate = new Date(endDateArr[0], parseInt(endDateArr[1]) - 1, endDateArr[2]);
  const offset = startDate.getDay(); //4
  let startSunday = new Date(startDate);
  startSunday.setDate(startDate.getDate() - offset);
  const offset1 = 6 - endDate.getDay();
  let endSaturday = new Date(endDate);
  endSaturday.setDate(endDate.getDate() + offset1);

  const [targetDate, setTargetDate] = useState(startSunday);
  let targetDateEnd = new Date(targetDate);
  targetDateEnd.setDate(targetDateEnd.getDate() + 6);

  // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
  const [selectedDate, setSelectedDate] = useState(autoSelect ? startDate : null);
  const [activeDate, setActiveDate] = useState(startDate);
  const [navDisable, setNavDisable] = useState({
    prev: targetDate <= startSunday,
    next: targetDateEnd >= endSaturday,
  });

  const [displayLabelStart, setDisplayLabelStart] = useState(startSunday);
  const temp = new Date(startSunday);
  temp.setDate(temp.getDate() + 6);
  const [displayLabelEnd, setDisplayLabelEnd] = useState(temp);

  const [navMonth, setNavMonth] = useState(selectedDate || startDate);

  // 접수시 빠른일정 제공 기능 - 자동선택 ON 25-06
  useEffect(() => {
    if (!possibleDate) return;

    console.log('possible date is updated...start date click....');
    handleClickDay(startDate);
  }, [possibleDate]);

  const clickArrow = (e) => {
    // const { action, activeStartDate, value, view } = e;
    const action = e.action;
    console.log('[action click]::', action);
    if (action === 'next') {
      if (navDisable.next) {
        setTargetDate((prev) => prev);
        setActiveDate((prev) => prev);
      } else {
        setTargetDate((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() + 7);
          updateArrow(temp);
          return temp;
        });
        setActiveDate((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() + 7);
          return temp;
        });
        setDisplayLabelStart((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() + 7);
          return temp;
        });
        setDisplayLabelEnd((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() + 7);
          return temp;
        });
        setNavMonth((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() + 7);
          return temp;
        });
      }
    } else if (action === 'prev') {
      if (navDisable.prev) {
        setTargetDate((prev) => prev);
        setActiveDate((prev) => prev);
      } else {
        setTargetDate((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() - 7);
          updateArrow(temp);
          return temp;
        });
        setActiveDate((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() - 7);
          return temp;
        });
        setDisplayLabelStart((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() - 7);
          return temp;
        });
        setDisplayLabelEnd((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() - 7);
          return temp;
        });
        setNavMonth((prevDate) => {
          let temp = new Date(prevDate);
          temp.setDate(prevDate.getDate() - 7);
          return temp;
        });
      }
    }
  };
  const updateArrow = (newTargetDate) => {
    let targetDateEnd = new Date(newTargetDate);
    targetDateEnd.setDate(targetDateEnd.getDate() + 6);
    setNavDisable((prv) => ({
      ...prv,
      prev: newTargetDate <= startSunday,
      next: targetDateEnd >= endSaturday,
    }));
  };
  function date2Time(holiDt2) {
    const splt = holiDt2.split('.');
    return new Date(splt[0], parseInt(splt[1]) - 1, splt[2]).getTime();
  }
  const availableDateArr = data.map((dt) => date2Time(dt.holiDt2));

  const display = (date) => {
    let targetEndDate = new Date(targetDate);
    targetEndDate.setDate(targetDate.getDate() + 6);
    if (date > targetEndDate || date < targetDate) return classes.tilesHidden;
    else if (date < startSunday) return classes.tilesHidden;
    else if (date < startDate) return classes.tilesDisabled;
    else if (date <= endDate) {
      if (selectedDate && date.getTime() === selectedDate.getTime()) {
        return classes.tilesAvailableSelected;
      } else {
        if (availableDateArr.includes(date.getTime())) {
          return classes.tilesAvailable;
        } else return classes.tilesDisabled;
      }
    } else if (date <= endSaturday) return classes.tilesDisabled;
    else return classes.tilesHidden;
  };
  const setNavLabel = ({ date, label, locale, view }) => {
    // console.log(">>>>>>>>>", date, label, locale, view)
    return (
      <>
        <div className={classes.label1}>{moment(navMonth).format('YYYY.MM')}</div>
        <div className={classes.label2}>
          {moment(displayLabelStart).format('MM.DD')}~
          {moment(displayLabelEnd).format('MM.DD')}
        </div>
      </>
    );
  };
  const setDateTile = (locale, date) => {
    return (
      <span
        className={[
          classes.calendarTileBtn,
          date.getDay() === 0
            ? classes.calendarTileBtnSun
            : date.getDay() === 6
            ? classes.calendarTileBtnSat
            : '',
        ].join(' ')}
      >
        {date.getDate()}
      </span>
    );
  };
  const NextWeek = ({ navDisableVal }) => {
    return (
      <img
        src={ArrowRight}
        className={navDisableVal ? classes.navIconDisable : classes.navIcon}
        alt="다음주로 이동"
      />
    );
  };
  const PrevWeek = ({ navDisableVal }) => {
    return (
      <img
        src={ArrowLeft}
        className={navDisableVal ? classes.navIconDisable : classes.navIcon}
        alt="이전주로 이동"
      />
    );
  };

  const handleClickDay = (val) => {
    data.forEach((el) => {
      if (val.getTime() === date2Time(el.holiDt2)) {
        // scheduleUnlock();
        setSelectedDate(val);
        setNavMonth(val);
        getPossibleTime(el);
      }
    });
  };

  return (
    <Fragment>
      <div className={classes.calendar}>
        <Calendar
          next2Label={null}
          prev2Label={null}
          calendarType="US"
          nextLabel={<NextWeek navDisableVal={navDisable.next} />}
          prevLabel={<PrevWeek navDisableVal={navDisable.prev} />}
          value={selectedDate}
          tileClassName={({ activeStartDate, date, view }) => display(date)}
          tileDisabled={({ date }) => date < startDate || date > endDate}
          formatDay={setDateTile}
          navigationLabel={setNavLabel}
          minDetail="month"
          maxDetail="month"
          onClickDay={handleClickDay}
          activeStartDate={activeDate}
          onActiveStartDateChange={clickArrow}
          defaultValue={startDate}
          formatShortWeekday={(_, date) =>
            ['일', '월', '화', '수', '목', '금', '토'][date.getDay()]
          }
        />
        <div className={classes.legend}>
          <span className={classes.legendAvailble}> 예약가능 </span>
          <span className={classes.legendSelected}> 선택 </span>
          <span className={classes.legendDisable}> 불가 </span>
        </div>
      </div>
    </Fragment>
  );
}
export default withStyles(styles)(WeekView);
